export class SessionDelegate {
    canvasNeeded: any = null;
    retireCanvas: any = null;
    monitorBounds: any = null;
}
